const e = {
  name: "DiamondLuxury",
  dimensions: { width: 40, height: 37 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36.7" style="enable-background:new 0 0 40 36.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,12.2L33.8,0L6.4,0.1L0,12.2l20,24.5L40,12.2z M8.8,2.1l9.4,0l-4.7,7.4L8.8,2.1z M12.1,11.1H2.9l4.2-8
			L12.1,11.1z M14.8,11.1L20,2.9l5.2,8.1H14.8z M31.2,2l-4.7,7.4L21.8,2L31.2,2z M20,31.6l-5.7-18.6h11.3L20,31.6z M27.7,13.1h9
			L22.4,30.5L27.7,13.1z M12.2,13.1l5.3,17.4L3.3,13.1H12.2z M37.1,11.1h-9.4L33,2.9L37.1,11.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as DiamondLuxury
};
